<template>
  <div class="w3-top" style="position:sticky; z-index: 10;">
    <div class="w3-bar navStyle" id="myNavbar">
      <a href="#home" class="w3-bar-item w3-button w3-wide">
        <!-- <strong style="background: linear-gradient(135deg, #363e3a 0%, #a67bd2 100%);color:white;">kli</strong>         -->
        <strong class="bluesh">klibase</strong>
        <strong style="background: linear-gradient(135deg, #faa6be 0%, #a2764b 100%);color:white;">soft</strong><strong id="animated-strong">.</strong>        
      </a>

      <div class="w3-right w3-hide-small">
        <!-- <a href="#about" class="w3-bar-item w3-button">{{ $t('nav.about') }}</a> -->
        <a href="#about" class="w3-bar-item w3-button">
          <span class="redsh">{{ $t('nav.about') }}</span>
        </a>
        <!-- <a href="#team" class="w3-bar-item w3-button"> -->
        <!-- <i class="fa fa-user"></i>  -->
        <!-- <span class="redsh">{{ $t('nav.team') }}</span> -->
        <!-- </a> -->
        <a href="#work" class="w3-bar-item w3-button">
          <!-- <i class="fa fa-th"></i>  -->
          <span class="redsh">{{ $t('nav.work') }}</span>
        </a>
        <a href="#contact" class="w3-bar-item w3-button">
          <!-- <i class="fa fa-envelope"></i>  -->
          <span class="redsh">{{ $t('nav.contact') }}</span>
        </a>
        <!-- <a class="w3-bar-item w3-button lang-switcher" @click="$emit('switch-language', currentLang === 'ru' ? 'en' : 'ru')">
          <i class="fa fa-globe"></i> {{ $t('nav.language') }}
        </a> -->
        <a class="w3-bar-item ">
          <LanguageSwitcher />
        </a>
      </div>

      <a href="javascript:void(0)" class="w3-bar-item w3-button w3-right w3-hide-large w3-hide-medium"
        @click="toggleSidebar">
        <i class="fa fa-bars"></i>
      </a>
    </div>

    <!-- Overlay для закрытия по клику вне сайдбара -->
    <div v-if="sidebarVisible" class="sidebar-overlay" @click="closeSidebar"></div>

    <nav class="w3-sidebar w3-bar-block w3-black w3-card w3-animate-left w3-hide-medium w3-hide-large"
      style=" opacity: 0.95; " :style="{ display: sidebarVisible ? 'block' : 'none' }" id="mySidebar" ref="sidebar">
      <a href="#home" @click="closeSidebar" class="w3-bar-item w3-button w3-large w3-padding-16">
        {{ $t('footer.toTop') }} ×
      </a>
      <a href="#about" @click="closeSidebar" class="w3-bar-item w3-button">{{ $t('nav.about') }}</a>
      <a href="#team" @click="closeSidebar" class="w3-bar-item w3-button">{{ $t('nav.team') }}</a>
      <a href="#work" @click="closeSidebar" class="w3-bar-item w3-button">{{ $t('nav.work') }}</a>
      <a href="#contact" @click="closeSidebar" class="w3-bar-item w3-button">{{ $t('nav.contact') }}</a>
      <a class="w3-bar-item">
        <LanguageSwitcher />
      </a>
    </nav>
  </div>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  name: 'NavbarSect',
  props: {
    currentLang: String
  },
  components: {
    LanguageSwitcher: LanguageSwitcher,
  },
  data() {
    return {
      sidebarVisible: false
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible
    },
    closeSidebar() {
      this.sidebarVisible = false
    },
    handleClickOutside(event) {
      const sidebar = this.$refs.sidebar
      const menuButton = document.querySelector('.w3-bar .w3-button .fa-bars')?.closest('.w3-button')

      // Закрываем сайдбар если клик был вне его и не по кнопке меню
      if (this.sidebarVisible &&
        sidebar &&
        !sidebar.contains(event.target) &&
        (!menuButton || !menuButton.contains(event.target))) {
        this.closeSidebar()
      }
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.sidebarVisible) {
        this.closeSidebar()
      }
    }
  },
  mounted() {
    // Добавляем обработчики событий
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('keydown', this.handleEscapeKey)
  },
  beforeUnmount() {
    // Убираем обработчики при уничтожении компонента
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('keydown', this.handleEscapeKey)
  }
}
</script>

<style scoped>
.navStyle {
  background-color: rgba(255, 255, 255, 1);
  /* opacity: 0.95; */
  /* backdrop-filter: blur(80px); */
  /* box-shadow: 0 2px 4px 0 rgba(40, 19, 88, 0.2), 0 2px 10px 0 rgba(78, 81, 107, 0.19); */
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.15);
}

#animated-strong {
            animation: flashRed 1.5s infinite;
        }
        
        @keyframes flashRed {
            0% {
                background: white;
            }
            50% {
                background: linear-gradient(135deg, #ea667e 0%, #a2764b 100%);
                color: white;
            }
            100% {
                background: white;
            }
        }
</style>